<template>
  <div>
    <div v-if="facility=='app'" class="content">
      <App/>
    </div>
    <div v-else>
      <Pc/>
    </div>
  </div>
</template>

<script>
import App from "./app";
import Pc from "./pc";
export default {
  components:{
    App,
    Pc,
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>

</style>